import {GiustificativoRecord} from "@commons/mapping/GiustificativoRecord";
import {LavoratoreStatusRecord} from "@commons/mapping/LavoratoreStatusRecord";
import {TipoGiu} from "@commons/mapping/Giustificativi";
import {isArray} from "lodash";

export class GiustificativoFilter {

    static filterTipoGiu = (giu: GiustificativoRecord, tipoGiu: TipoGiu | TipoGiu[] | null) => {
        if (!tipoGiu) {
            return true;
        } else if (isArray(tipoGiu)) {
            const tipoTrovato = tipoGiu.find(tipo => tipo === giu.tipoGiu)
            return !!tipoTrovato;
        } else {
            return (giu.tipoGiu === tipoGiu);
        }
    }

    static filterHasStatus = (giu: GiustificativoRecord, status: LavoratoreStatusRecord[]) => {
        if (!giu.status || giu.status.length === 0)
            return true;
        else {
            if (!status || status.length === 0) {
                console.warn(`Lavoratore senza status!`);
                return false;
            }

            for (const statusGiu of giu.status) {
                const statusLav = status.find((s) => s.codice === statusGiu.id)
                if (statusLav)
                    return true;
            }
        }
        return false;
    }

    static filterProfiloGiu = (giu: GiustificativoRecord) => {
        if (!giu || !giu.idProfiloGiu) {
            return true;
        } else {
            return giu.idProfiloGiu > 0;
        }
    }
}